// Que se puede adjuntar a la nota de una poliza.
//
// Jennifer Acevedo (Pomares Insurance Group), 2026-08-21: "con los documentos
// en pdf ya podemos cargarlo, pero los audios no me los aceptan".
//
// El 2026-08-20 se abrio la puerta a PDF y audio, y la parte de PDF funciono.
// La de audio no, y el motivo es que la comprobacion mira SOLO LA EXTENSION
// contra una lista que se quedo corta. Faltaba justo lo que la gente reenvia:
//
//   .amr   nota de voz de WhatsApp en muchos Android, y casi todos los
//          buzones de voz de centralita
//   .webm  lo que graban los navegadores (estaba `weba`, que casi nadie usa)
//   .3gp   grabadora de voz de Android antiguo
//   .wma   grabadora de Windows
//   .flac, .aiff, .caf  exportaciones de Mac y de equipos de grabacion
//
// Y lo que convertia el fallo en un misterio: al rechazar, el mensaje decia
// "se admiten fotos, PDF y audio" mientras rechazaba un audio. Quien lo lee
// concluye, con razon, que los audios no se aceptan.
//
// LA REGLA DE FONDO: la extension es una PISTA, no la verdad. Si el navegador
// declara que el archivo es `audio/algo`, eso manda — aunque su extension no
// este en ninguna lista. La lista solo hace falta cuando no hay tipo, que pasa
// con archivos reenviados.

export const EXT_AUDIO = [
  'mp3', 'm4a', 'm4b', 'mp4a', 'aac', 'wav', 'wave',
  'ogg', 'oga', 'opus', 'weba', 'webm',
  'amr', '3gp', '3gpp', 'wma', 'flac', 'aif', 'aiff', 'caf', 'mid',
];
export const EXT_IMAGEN = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'heic', 'heif'];
export const EXT_DOC = ['pdf'];
export const EXT_ADMITIDAS = [...EXT_IMAGEN, ...EXT_DOC, ...EXT_AUDIO];

// Lo que se le ofrece al selector de archivos del sistema. Los `audio/*` e
// `image/*` cubren lo que el navegador sepa clasificar; las extensiones
// sueltas rescatan lo que no clasifica (en Windows, un .amr suele llegar sin
// tipo y el selector lo ocultaria).
export const ACEPTA_NOTA = [
  'image/*', 'application/pdf', 'audio/*',
  ...EXT_ADMITIDAS.map((e) => '.' + e),
].join(',');

export function extensionDe(nombre) {
  const limpio = String(nombre || '').split('?')[0];
  const punto = limpio.lastIndexOf('.');
  return punto === -1 ? '' : limpio.slice(punto + 1).toLowerCase();
}

// El tipo declarado MANDA sobre la extension.
export function tipoAdmitido(mime) {
  const t = String(mime || '').toLowerCase();
  return t.startsWith('image/') || t.startsWith('audio/') || t === 'application/pdf';
}

export function archivoAdmitido(file) {
  if (!file) return false;
  if (tipoAdmitido(file.type)) return true;
  return EXT_ADMITIDAS.includes(extensionDe(file.name));
}

// Por que NO se admite, en palabras que sirvan. Decir "se admiten fotos, PDF y
// audio" mientras se rechaza un audio es lo que hizo que este fallo pareciera
// otra cosa.
export function motivoRechazo(file, es) {
  const nombre = (file && file.name) || (es ? 'ese archivo' : 'that file');
  const ext = extensionDe(file && file.name);
  if (ext) {
    return es
      ? `"${nombre}": el formato .${ext} no se admite. Se aceptan fotos, PDF y audio (mp3, m4a, ogg, opus, amr, wav...).`
      : `"${nombre}": .${ext} files aren't supported. Photos, PDF and audio are (mp3, m4a, ogg, opus, amr, wav...).`;
  }
  return es
    ? `"${nombre}" no tiene extension, asi que no se puede saber que es. Renombralo anadiendo por ejemplo .mp3 o .pdf.`
    : `"${nombre}" has no extension, so its type can't be determined. Rename it adding e.g. .mp3 or .pdf.`;
}


// ── QUE ES ESTE ADJUNTO Y COMO SE LLAMA ──────────────────────────────────────
//
// Vivian dentro de PoliciesView.jsx. Se traen aqui —al lado de las listas de
// extensiones de las que dependen— el 2026-09-11, al abrir los adjuntos de
// TAREAS a PDF y audio (ticket de Asniel Lopez, Pomares Insurance Group): con
// una copia en cada pantalla, el dia que una aprenda a reconocer un formato
// nuevo la otra se queda atras sin que nada avise.
/**
 * Qué es este adjunto, mirando la URL.
 *
 * La URL viene firmada (`...archivo.pdf?sv=...&sig=...`), así que hay que
 * cortar por el "?" antes de leer la extensión — de eso se encarga
 * `extensionDe`. Sin ese corte, la firma se lleva por delante la detección y
 * TODO acaba pintado como foto: un PDF dentro de un <img> sale como una imagen
 * rota, sin decir qué es ni dejar abrirlo.
 */
export function tipoAdjunto(url) {
  const ext = extensionDe(String(url || '').split('/').pop());
  if (EXT_AUDIO.includes(ext)) return 'audio';
  if (EXT_DOC.includes(ext)) return 'pdf';
  if (EXT_IMAGEN.includes(ext)) return 'imagen';
  // Desconocido: se trata como archivo, no como imagen. Un enlace que se puede
  // abrir siempre es mejor que un hueco roto.
  return 'archivo';
}

/** El nombre legible del archivo, sin el prefijo aleatorio del blob. */
export function nombreAdjunto(url) {
  const base = decodeURIComponent(String(url || '').split('?')[0].split('/').pop() || '');
  return base.replace(/^[A-Za-z0-9_-]{6,}-/, '') || base;
}
